/**
 * Shared CSS class for To/UFS inputs. Text size and padding aligned with workflow form fields (From, Date, RE, Body).
 */
export const TO_UFS_INPUT_CLASS =
  'w-full rounded-lg px-3 py-2 text-sm text-slate-700 border border-gray-300 bg-white shadow-sm focus:border-primary-dark focus:outline-none focus:ring-1 focus:ring-primary-dark/40 transition';

/** Input class when To/UFS field is disabled or read-only (grayed-out text fields). */
export const TO_UFS_INPUT_CLASS_DISABLED =
  'w-full rounded-lg px-3 py-2 text-sm text-slate-600 border border-gray-300/50 bg-gray-300/50 shadow-sm cursor-not-allowed';
